import React from 'react';
import { IOrder } from '@/interfaces/order';
import TemplateHeader from './components/template-header';
import TemplateOrderInfoItem from './components/template-order-info-item';
import { ICndn } from '@/interfaces/cndn';
import { ECndnReason, ECndnType } from '@/enums/ECndn';
import TemplateCndnInfoSecond from './components/template-cndn-info-second';
import TemplateCndnInfoItem from './components/template-cndn-info-item';
import TemplateFooter from './components/template-footer';
import TemplateCndnInfo from './components/template-cndn-info';
import { getCndnTypeName } from '@/helpers/cndnHelper';

interface IProps {
  data: IOrder;
  cndn: ICndn;
}

const TM25 = ({ data, cndn }: IProps) => {
  const docNameTH = cndn.type == ECndnType.CREDIT ? 'ใบลดหนี้' : 'ใบเพิ่มหนี้';
  const docNameEN =
    cndn.type == ECndnType.CREDIT ? 'Credit Note' : 'Debit Note';
  const desc = cndn?.taxRate > 0 ? 'ใบกำกับภาษี' : 'ไม่ใช่ใบกำกับภาษี';
  if ((data?.orderItems?.length || 0) > 2) {
    const items =
      cndn.reason == ECndnReason.RETURN_GOOD
        ? cndn?.creditDebitNoteItems?.filter(c => Number(c.quantity) > 0)
        : cndn?.creditDebitNoteItems?.filter(c => Number(c.unitPrice) > 0);
    return (
      <>
        <div
          style={{
            maxWidth: '209mm',
            minWidth: '209mm',
            minHeight: '296mm',
            maxHeight: '296mm',
            backgroundColor: 'white',
            margin: '0px auto',
            position: 'relative',
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 10,
            paddingBottom: 10,
            pageBreakBefore: 'always',
          }}
        >
          <TemplateHeader
            description={desc}
            titleEn={docNameEN}
            titleTh={docNameTH}
            businessUnitLogo={data.businessUnitLogo}
            otherDescription={'สำเนา'}
          />
          <TemplateCndnInfo
            data={data}
            code={cndn.code}
            cndnType={cndn.type}
            docDate={cndn.docDate}
          />
          <TemplateCndnInfoSecond data={data} cndn={cndn} />
          <p className="mt-4 font-bold">รายการตามใบแจ้งหนี้เดิม</p>
          <TemplateOrderInfoItem
            data={data}
            isShowPrice
            items={data.orderItems}
            isShowTotal={false}
          />
          <TemplateFooter
            paidInfoTemplate="TM04"
            footerTextLeft="ต้นฉบับ - ORIGINAL"
            footerTextRight="ต้นฉบับ - นำกลับบริษัท"
            referenceNo1={data?.customer?.reference1 || ''}
            referenceNo2={data?.customer?.reference2 || ''}
            amount={data?.summary}
            customerCode={data?.customer?.code || ''}
            ivNo={data?.ivNo}
            showFooter={false}
            isInvoice
            isReceive={false}
            docNo={data?.code}
            page="1/2"
            isMultiPage
          />
        </div>
        <div
          style={{
            maxWidth: '209mm',
            minWidth: '209mm',
            minHeight: '296mm',
            maxHeight: '296mm',
            backgroundColor: 'white',
            margin: '0px auto',
            position: 'relative',
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 10,
            paddingBottom: 10,
            pageBreakBefore: 'always',
          }}
        >
          <TemplateHeader
            description={desc}
            titleEn={docNameEN}
            titleTh={docNameTH}
            businessUnitLogo={data.businessUnitLogo}
            otherDescription={'สำเนา'}
          />
          <p className="mt-4 font-bold">{`รายการ${getCndnTypeName(cndn.type)}`}</p>
          <TemplateCndnInfoItem data={cndn} items={items} />
          <TemplateFooter
            paidInfoTemplate="TM24"
            footerTextLeft="สำเนา - COPY"
            footerTextRight="สำเนา - นำกลับบริษัท"
            referenceNo1={data?.customer?.reference1 || ''}
            referenceNo2={data?.customer?.reference2 || ''}
            amount={data?.summary}
            customerCode={data?.customer?.code || ''}
            ivNo={data?.ivNo}
            isReceive={false}
            showFooter={false}
            isReceipt
            docNo={data?.code}
            isMultiPage={false}
            isCndn
            page="2/2"
          />
        </div>
      </>
    );
  }

  const items =
    cndn.reason == ECndnReason.RETURN_GOOD
      ? cndn?.creditDebitNoteItems?.filter(c => Number(c.quantity) > 0)
      : cndn?.creditDebitNoteItems?.filter(c => Number(c.unitPrice) > 0);
  return (
    <div
      style={{
        maxWidth: '209mm',
        minWidth: '209mm',
        minHeight: '296mm',
        maxHeight: '296mm',
        backgroundColor: 'white',
        margin: '0px auto',
        position: 'relative',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
        pageBreakBefore: 'always',
      }}
    >
      <TemplateHeader
        description={desc}
        titleEn={docNameEN}
        titleTh={docNameTH}
        businessUnitLogo={data.businessUnitLogo}
        otherDescription={'สำเนา'}
      />
      <TemplateCndnInfo
        data={data}
        code={cndn.code}
        cndnType={cndn.type}
        docDate={cndn.docDate}
      />
      <TemplateCndnInfoSecond data={data} cndn={cndn} />
      <p className="mt-4 font-bold">รายการตามใบแจ้งหนี้เดิม</p>
      <TemplateOrderInfoItem
        data={data}
        isShowPrice
        items={data.orderItems}
        isShowTotal={false}
      />
      <p className="mt-4 font-bold">{`รายการ${getCndnTypeName(cndn.type)}`}</p>
      <TemplateCndnInfoItem data={cndn} items={items} />
      <TemplateFooter
        paidInfoTemplate="TM24"
        footerTextLeft="สำเนา - COPY"
        footerTextRight="สำเนา - นำกลับบริษัท"
        referenceNo1={data?.customer?.reference1 || ''}
        referenceNo2={data?.customer?.reference2 || ''}
        amount={data?.summary}
        customerCode={data?.customer?.code || ''}
        ivNo={data?.ivNo}
        isReceive={false}
        showFooter={false}
        isReceipt
        docNo={data?.code}
        isMultiPage={false}
        isCndn
        signature={data?.businessUnitSignature}
      />
    </div>
  );
};

export default TM25;
